/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography } from '@material-ui/core';
// import PropTypes from 'prop-types';
import SliderOne from './../../img/chana.jpg';
import SliderTwo from './../../img/image.png';
import Carousel from 'react-material-ui-carousel';
import { Paper } from '@mui/material';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';


import style from './style';

const Item = (props) => {
  let { img } = props?.item
  return (
    <Paper>
      <img width="100%" height="30%" src={img} alt="" />
    </Paper>
  )
}
const ProducItemAtom = (props) => {
  const classes = style();
  let items = [
    {
      img: SliderOne
    },
    {
      img: SliderTwo
    }
  ];

  return (
    <Box style={{ position: 'relative' }}>
      <Box className={classes.boxCorner}>
        {/* <Carousel> { items.map( (item, i) => <Item key={i} item={item} /> ) } </Carousel> */}
        <img width="100%" height="300px" src={props.image} alt="" />

      </Box>

      <Box className={`${classes.contetnArrange}`}>
        <Box style={{ width: "100%", color: "white", borderRadius: "0 0 5px 5px" }}>
          {props.isPublic ?
            <Box style={{ backgroundImage: "linear-gradient(to top, rgba(0, 0, 0, 0.21) 4%, rgba(0, 0, 0, 0.92))", padding: 10 }}>
              <Typography >
                यह सौदा सार्वजनिक है।
              </Typography>
            </Box>
            :
            <Box style={{ background: "none", height: "45px" }}></Box>
          }

          <Box style={{ background: "none", height: "145px" }}>

          </Box>
          <Box style={{ backgroundImage: "linear-gradient(to bottom, rgba(0, 0, 0, 0.51) 1%, rgba(0, 0, 0, 0.92))" }}>
            <Box style={{ padding: "10px 0px", display: "grid", gridTemplateColumns: "55% 45%" }}>

              <Box style={{ display: "grid", gridTemplateColumns: "20% 80%" }}>
                <Box style={{ textAlign: "center" }}>
                  <AgricultureIcon /><br />
                  <Typography style={{ fontSize: 9, marginTop: "-5px" }}>
                    फसल
                  </Typography>
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                    {props.productName}
                  </Typography>
                </Box>



              </Box>

              <Box style={{ display: "grid", gridTemplateColumns: "30% 70%" }}>
                <Box style={{ textAlign: "center" }}>
                  <CurrencyRupeeIcon /><br />
                  <Typography style={{ fontSize: 9, marginTop: "-5px" }}>
                    कीमत
                  </Typography>
                </Box>

                <Box>
                  <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                    Rs. {props.minPrice}-{props.maxPrice}*
                  </Typography>
                </Box>


              </Box>

            </Box>
            <Box style={{ padding: "10px 0px", display: "grid", gridTemplateColumns: "55% 45%", }}>

              <Box style={{ display: "grid", gridTemplateColumns: "20% 80%" }}>
                <Box style={{ textAlign: "center" }}>
                  <FmdGoodIcon /><br />
                  <Typography style={{ fontSize: 9, marginTop: "-5px" }}>
                    स्थान
                  </Typography>
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                    {props.place}
                  </Typography>
                </Box>


              </Box>

              <Box style={{ display: "grid", gridTemplateColumns: "30% 70%" }}>
                <Box style={{ textAlign: "center" }}>
                  <ProductionQuantityLimitsIcon /><br />
                  <Typography style={{ fontSize: 9, marginTop: "-5px" }}>
                    लौट साइज
                  </Typography>
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                    {props.quantity} {props.quantityUnit}
                  </Typography>
                </Box>


              </Box>

            </Box>
            {/* <Box style={{ height: "55px" }}>

            </Box> */}
          </Box>

        </Box>

        {/* <Box>
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            {props.productName}
          </Typography>
          <Typography variant="body1">
            वस्तु
          </Typography>
        </Box>
        <Box>
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            Rs. {props.minPrice}-{props.maxPrice}*
          </Typography>
          <Typography variant="body1">
            कीमत
          </Typography>
        </Box>
        <Box>
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            {props.place}
          </Typography>
          <Typography variant="body1">
            स्थान
          </Typography>
        </Box>
        <Box>
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            {props.quantity} {props.quantityUnit}
          </Typography>
          <Typography variant="body1">
            लौट साइज
          </Typography>
        </Box> */}
      </Box>
    </Box>
  );
}

export default ProducItemAtom;